import React, { Component } from 'react'
import BaseHeader from '../shared/Section/Header'

export class Header extends Component {
  render() {
    return (
      <BaseHeader
        headline="Testimonials"
        title="5000+ happy clients all around the world"
      ></BaseHeader>
    )
  }
}

export default Header
